import Meals from "../components/Meals/Meals";

function HomePage() {
  return <Meals></Meals>;
}

export default HomePage;
